<swal #warnAlert
  title="Warning" i18n-title
  text="Are you sure you want to delete this Fee Earner?" i18n-text
  icon="warning"
  [swalOptions]="swalOptions">
</swal>
<form fxLayout="row" [formGroup]="feeSplitForm" novalidate>
  <div class="fee-split" fxLayout="row wrap">
    <div
      [ivEnabledForPartialCredit]="{ 'editable': false, 'transaction': transaction }"
      class="fee-split__broker" fxFlex="30">
      <iv-broker-search-field
        [index]="feeSplitIndex"
        [billExternal]="feeSplitForm.get('bill_external').value"
        [showExternal]=false
        [brokerDetails]="feeSplit.broker_details"
        [name]="feeSplit.name"
        [email]="feeSplit.email"
        [crossBorder]="feeSplit.cross_border"
        (selectBroker)="brokerSelected($event)"
        [showBrokerSearchLabel]="false"
        [disabled]="feeSplit.bill_external !== feeSplitForm.get('bill_external').value">
      </iv-broker-search-field>
      <div class="formfields fee-split__broker__amount_percent" fxLayout="row wrap">
        <div class="formfields__container" fxFlex="60">
          <iv-currency-field
            label="Fee" i18n-label
            [required]="true"
            controlName="flat_amount_{{feeSplitIndex}}"
            prefixed="true"
            [formControl]="feeSplitForm.get('flat_amount')"
            [currency]="currencySymbol"
          ></iv-currency-field>
        </div>
        <div
          [ivEnabledForPartialCredit]="{ 'editable': true, 'transaction': transaction }"
          class="formfields__container end" fxFlex="40">
          <mat-form-field>
            <label for="fee-percent" i18n>Fee %</label>
            <input
              id="fee-percent_{{feeSplitIndex}}"
              class="input-counter"
              formControlName="percent_output"
              matInput
              type="number"
              [max]="maxPercent"
              min="0"
              />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>
      </div>
      <div class="formfields fee-split__broker__amount_percent" fxLayout="row wrap" *ngIf="showDisbursement">
        <div class="formfields__container" fxFlex="60">
          <iv-currency-field
            label="Disbursement" i18n-label
            controlName="disbursement_allocation_amount_{{feeSplitIndex}}"
            prefixed="true"
            [formControl]="feeSplitForm.get('disbursement_allocation_amount')"
            [currency]="currencySymbol"
            [disabled]="true">
          </iv-currency-field>
        </div>
        <div class="formfields__container end" fxFlex="40">
          <iv-decimal-field
            label="Disb %" i18n-label
            [suffix]="'%'"
            controlName="disbursement_allocation_percent_{{feeSplitIndex}}"
            [formControl]="feeSplitForm.get('disbursement_allocation_percent')"
            [disabled]="true"
          ></iv-decimal-field>
        </div>
      </div>
      <div class="formfields fee-split__broker__amount_percent" fxLayout="column wrap">
        <div class="formfields__container end" fxFlex="100" *ngIf="!showSMF()">
          <iv-currency-field
            label="SMF" i18n-label
            controlName="smf_{{feeSplitIndex}}"
            prefixed="true"
            [formControl]="feeSplitForm.get('smf')"
            [currency]="currencySymbol"
            [disabled]="true">
          </iv-currency-field>
        </div>
        <div class="formfields__container end" fxFlex="100">
          <iv-currency-field
            label="DED"
            controlName="akol_ded_{{feeSplitIndex}}"
            prefixed="true"
            [formControl]="feeSplitForm.get('akol_ded')"
            [currency]="currencySymbol"
            [disabled]="true">
          </iv-currency-field>
        </div>
        <div class="formfields__container end" fxFlex="100">
          <iv-currency-field
            label="Actual Fee" i18n-label
            controlName="actual_fee_{{feeSplitIndex}}"
            prefixed="true"
            [formControl]="feeSplitForm.get('actual_fee')"
            [currency]="currencySymbol"
            [disabled]="true">
          </iv-currency-field>
        </div>
      </div>
    </div>

    <div [ivEnabledForPartialCredit]="{ 'editable': false, 'transaction': transaction }" class="fee-split__details" fxFlex="66">
      <div class="formfields" fxLayout="row wrap">
        <div class="formfields__container" fxFlex="50" fxFlex.gt-md="50">
          <mat-checkbox
            class="e2e-conjuctional-agent"
            formControlName="bill_external" i18n id='e2efeesplit-{{feeSplitIndex}}'
            (change)="togglingFormControl('primary_employee', feeSplitForm.get('bill_external').value, 'bill_external')"
            color="primary">
            CBRE is paying the Conjunctional Agent
          </mat-checkbox>
        </div>
        <div id="e2e-primary-employee_{{feeSplitIndex}}" class="formfields__container" fxFlex="30" fxFlex.gt-md="30">
          <mat-checkbox
            id="fee-split-primary-checkbox_{{feeSplitIndex}}"
            formControlName="primary_employee" i18n
            (change)="broadcastPrimaryEmployee()"
            color="primary">
            Primary Employee
          </mat-checkbox>
        </div>
        <div *ngIf="showGreenSpace(feeSplit)"
          class="formfields__container" fxFlex="20">
          <mat-checkbox
            id="greenspace_{{feeSplitIndex}}"
            formControlName="greenspace" i18n
            color="primary">
            Greenspace
          </mat-checkbox>
        </div>
      </div>
      <div class="formfields" fxLayout="row wrap">
        <div class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="50">
          <mat-form-field>
            <label for="fee-earner-role_{{feeSplitIndex}}"><span i18n>Role</span> <span class="required">*</span></label>
            <mat-select
              id="fee-earner-role_{{feeSplitIndex}}"
              formControlName="role"
              placeholder="Select One" i18n-placeholder
              floatPlaceholder="never">
              <mat-option *ngFor="let role of roles$ | async" [value]="role.value">
                <span class="fee-earner-role-{{role.value}}">{{ role.label }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="50"
          *ngIf="userCountry === 'IND' && ['valuation', 'consultation'].includes(transactionType) && feeSplitForm.get('primary_employee')?.value">
          <mat-form-field>
            <label for="fee-earner-functional-unit_{{feeSplitIndex}}">
              <span i18n>Functional Unit</span> <span class="required">*</span>
            </label>
            <mat-select 
              id="fee-earner-functional-unit_{{feeSplitIndex}}"
              formControlName="functional_unit"
              placeholder="Select One" i18n-placeholder
              floatPlaceholder="never">
              <mat-option *ngFor="let unit of functionalUnits$ | async" [value]="unit.value">
                <span class="fee-earner-role-{{unit.value}}">{{ unit.label }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="50">
          <ng-container *ngIf="!feeSplitForm.get('bill_external').value || feeSplit.cross_border">

            <ng-container *ngIf="feeSplit.broker_details.length > 1; else singleCompanyOfficeTemplate">
              <mat-form-field>
                <label for="fee-managing-office_{{feeSplitIndex}}" i18n>Company & Office</label>
                <mat-select
                  id="fee-managing-office_{{feeSplitIndex}}"
                  placeholder="Select One" i18n-placeholder
                  floatPlaceholder="never"
                  (selectionChange)="changeFuMo($event)"
                  [(value)]="selectedFuMo">
                  <mat-option *ngFor="let office of feeSplit.broker_details" value="{{ office.la_setid }}-{{ office.functional_unit.id }}-{{ office.managing_office.id }}">
                    <span class="fee-managing-office-{{ office.functional_unit.id }}-{{office.managing_office.id}}">{{ office.la_setid }} - {{ office.functional_unit.name }} - {{ office.managing_office.name }}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <ng-template #singleCompanyOfficeTemplate>
              <mat-form-field>
                <label i18n>Company & Office</label>
                <input
                  matInput
                  [value]="singleCompanyOffice"
                  [disabled]=true />
              </mat-form-field>
            </ng-template>

          </ng-container>

          <mat-form-field *ngIf="feeSplitForm.get('bill_external').value && !feeSplit.cross_border">
            <label i18n>Company & Office</label>
            <input
              matInput
              i18n-placeholder
              floatPlaceholder="never"
              formControlName="company_office" />
          </mat-form-field>
        </div>
        <div *ngIf="showLicenseNumberCheck()" class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="50">
          <mat-form-field>
            <label i18n>Employee License Number</label>
            <input
              matInput
              i18n-placeholder
              floatPlaceholder="never"
              [value]="feeSplit.license_number"
              [disabled]=true />
          </mat-form-field>
        </div>
        <div *ngIf="projectCodeRequired" class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="33">
          <mat-form-field>
            <label for="fee-earner-project-code_{{feeSplitIndex}}"><span i18n>Project Code</span> <span class="required">*</span></label>
            <input
              id="fee-earner-project-code_{{feeSplitIndex}}"
              matInput
              i18n-placeholder
              floatPlaceholder="never"
              [value]="projectCodeDisplay()"
              [matAutocomplete]="projectCodeAutocomplete"
              (keyup)="projectCodeTyped($event)"
              [disabled]=""/>
            <mat-autocomplete
              #projectCodeAutocomplete
              [displayWith]="projectCodeDisplay.bind(this)">
              <mat-option *ngFor="let projectCode of projectCodes$ | async"
                [value]="projectCode.id"
                (onSelectionChange)="projectCodeSelected(projectCode, $event)">
                <span class="fee-earner-project-code-{{projectCode.id}}">
                  {{projectCode.code}}: {{ projectCode.name }}
                </span>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <ng-container *ngIf="projectCodeRequired && myFinance === 'peoplesoft' && ['AUS', 'NZL', 'JPN'].includes(userCountry)">
          <div class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="33">
            <mat-form-field>
              <label for="fee-earner-activity_{{feeSplitIndex}}"><span i18n>Activity</span> <span class="required">*</span></label>
              <input
                id="fee-earner-activity_{{feeSplitIndex}}"
                matInput
                i18n-placeholder floatPlaceholder="never"
                [value]="selectedActivityName() || null"
                [disabled]="!feeSplitForm.get('project').value && feeSplitForm.get('project').value !== ''"
                [matAutocomplete]="activityAutocomplete"
                (keyup)="activityTyped($event)" />
              <mat-autocomplete
                #activityAutocomplete
                [displayWith]="selectedActivityName.bind(this)">
                <mat-option *ngFor="let activity of activities$ | async"
                  [value]="activity.id"
                  (onSelectionChange)="activitySelected(activity, $event)">
                  <span class="fee-earner-activity-{{activity.id}}">{{ activity.name }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="33">
            <mat-form-field>
              <label for="fee-earner-source-code_{{feeSplitIndex}}"><span i18n>Source Code</span> <span class="required">*</span></label>
              <input
                id="fee-earner-source-code_{{feeSplitIndex}}"
                matInput
                floatPlaceholder="never"
                [value]="selectedSourceCode?.name || null"
                [matAutocomplete]="sourceCodeAutocomplete"
                (keyup)="sourceCodeTyped($event)" />
              <mat-autocomplete
                #sourceCodeAutocomplete
                [displayWith]="selectedSourceCodeName.bind(this)">
                <mat-option *ngFor="let source_code of sourceCodes$ | async"
                  [value]="source_code.id"
                  (onSelectionChange)="sourceCodeSelected(source_code, $event)">
                  <span class="fee-earner-source-code-{{source_code.id}}">{{ source_code.name }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <div class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="33">
            <mat-form-field>
              <label for="fee-earner-category_{{feeSplitIndex}}">
                <span i18n>Category</span> 
                <span *ngIf="isCategoryMandatory" class="required">*</span>
              </label>
              <mat-select 
                id="fee-earner-category_{{feeSplitIndex}}"
                formControlName="category"
                placeholder="Select One" i18n-placeholder
                floatPlaceholder="never"
                [disabled]="!feeSplitForm.get('source_code').value && feeSplitForm.get('source_code').value !== '' || categories === null">
                <mat-option *ngFor="let category of categories$ | async"
                  [value]="category.id">
                  <span class="fee-earner-category-{{category.id}}">{{ category.name }}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

        <div *ngIf="feeSplit.cross_border" class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="33">
          <mat-form-field>
            <label i18n>Affiliate Code</label>
            <input matInput [value]="feeSplit.ext_affiliate_code_details | ivDisplayFn" disabled />
          </mat-form-field>
        </div>
        <div *ngIf="feeSplit.business_unit && myFinance === 'peoplesoft'" class="formfields__container" fxFlex="50" fxFlex.gt-md="50" fxFlex.gt-lg="33">
          <mat-form-field>
            <label i18n>Business Unit</label>
            <input matInput [value]="feeSplit.business_unit" disabled />
          </mat-form-field>
        </div>        
      </div>
    </div>
    <div class="fee-split__delete" fxFlex="4">
      <div class="delete-action">
        <button type="button" mat-icon-button (click)="showDeleteAlert()">
          <mat-icon color="warn">delete</mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>
